import React from 'react';

import { ImportTestCasesStatusContext } from '@qality/common-components/src/lib/ImportTestCasesStatusProvider';
import { DownloadService } from '@qality/common-service';

import { toText } from './DownloadLogs.converter';
import { DownloadLogsView } from './DownloadLogs.view';

export const DownloadLogs = () => {
  const { importResponse } = React.useContext(ImportTestCasesStatusContext);

  const downloadCSV = () => {
    DownloadService.downloadTxtFile('logs.txt', toText(importResponse.errors));
  };

  return <DownloadLogsView handleClick={downloadCSV} />;
};
